import React from 'react';

import ArrowRight from 'components/Icons/ArrowRight';
import CircleArrowRight from 'components/Icons/CircleArrowRight';

import * as Interfaces from '../../interfaces';
import { getNavId } from '../helpers';
import * as Styled from './styled';

export type ComponentProps = {
  /**
   * Whether this NavItem has been selected
   */
  isActive: boolean;
  /**
   * The items to be displayed in the Navigation
   */
  item: Interfaces.NavItem;

  /**
   * The column number the item is represented on
   */
  colNum: number;

  /**
   * The row number the item is represented on
   */
  rowNum: number;
  /**
   * Optional action to be fired when the navItem is hovered. Default to undefined (when the item rendered as a 3rd level sub-menu)
   */
  onSelect?: () => void;
  /**
   * Color scheme for this nav item. Defaults to DARK_GREY
   */
  colorScheme?: Interfaces.MenuColumnTheme;
};

const NavItem: React.FC<ComponentProps> = ({
  isActive,
  item,
  onSelect,
  colorScheme,
  colNum,
  rowNum
  // onItemClick = () => {}
}) => {
  const { text, href, subItems = [] } = item;
  const navId = getNavId(colNum, rowNum);

  const hasChildren = subItems.length > 0;

  return (
    <Styled.NavItem isActive={isActive} colorScheme={colorScheme}>
      <Styled.NavLink id={navId} href={href} onFocus={onSelect} onMouseEnter={onSelect}>
        <Styled.LinkText>{text}</Styled.LinkText>
        {hasChildren && (
          <>
            {isActive ? (
              <Styled.IconWrapper>
                <CircleArrowRight />
              </Styled.IconWrapper>
            ) : (
              <Styled.IconWrapperOutline>
                <ArrowRight />
              </Styled.IconWrapperOutline>
            )}
          </>
        )}
      </Styled.NavLink>
    </Styled.NavItem>
  );
};

export default React.memo(
  NavItem,
  (prevProps, nextProps) =>
    prevProps.item.id === nextProps.item.id && prevProps.isActive === nextProps.isActive
);
